import {Component} from "../Component";
import {element} from "../CustomElement";
import {inject} from "../../services/di";
import BreadcrumbsService from "../../services/BreadcrumbsService";
import {UserAgentService} from "../../services/UserAgentService";
import {FlyersViewedService} from "../../services/FlyersViewedService";
import {AppRating} from "../flipp-app-rating/AppRating";
import {i18n} from "../../i18n/I18n";
import {icons} from "../../icons/Icons";


@element("mobile-popup-banner")
export class MobilePopupBanner extends Component<{}, {}> {
	@inject userAgent: UserAgentService;
	@inject flyersViewedService: FlyersViewedService;
	@inject breadcrumbsService: BreadcrumbsService;

	onAttach() {
		window.addEventListener("display-mobile-popup-banner", this.show);
	}

	onDetach() {
		window.removeEventListener("display-mobile-popup-banner", this.show);
	}

	show = () => {
		this.invalidate();
	}

	hide = () => {
		this.flyersViewedService.hide();
		this.invalidate();
	}

	check() {
		if (this.isHidden()) {
			this.unblockWindow();
		} else {
			this.blockWindow();
		}
	}

	blockWindow() {
		const el = document.getElementsByClassName("application");
		if (el[0]) {
			el[0].classList.add("blocked");
		}
	}

	unblockWindow() {
		const el = document.getElementsByClassName("application");
		if (el[0]) {
			el[0].classList.remove("blocked");
		}
	}

	isHidden = () => !this.userAgent.mobile || this.flyersViewedService.isBannerHidden();

	render() {
		this.check();
		if (this.isHidden()) {
			return <div />;
		}
		return (
			<div class="mobile-popup-banner">
				<div class="mobile-popup-banner__title">
					{i18n("mobile_popup_banner")}
				</div>
				<div class="mobile-popup-banner__logo">
					<div>{icons.flippLogo}</div>
				</div>
				<div class="mobile-popup-banner__ratings">
					<AppRating />
				</div>
				<div class="mobile-popup-banner__get-app">
					<a href="https://flipp.app.link/htK7d2pTj9">
						{i18n("get_app")}
					</a>
				</div>
				<div
					class="mobile-popup-banner__hide-button"
					onClick={this.hide}
				>
					Continue in web browser
				</div>
			</div>
		);
	}
}
